<div [attr.data-automation]="dataAutomation()">
  @if (sectionType() === ExceptionHandlingSectionType.OVERFLOW) {
    <div class="row">
      <ziro-text class="col-6" [fieldId]="'overflowThreshold'" [inlineLabel]="false"></ziro-text>
    </div>
  }

  @if (sectionType() === ExceptionHandlingSectionType.TIMEOUT) {
    <div class="row">
      <ziro-text class="col-6" [fieldId]="'timeoutMinutes'" [inlineLabel]="false"></ziro-text>
      <ziro-select class="col-6" [fieldId]="'timeoutSeconds'" [inlineLabel]="false"></ziro-select>
    </div>
  }

  @if (sectionType() === ExceptionHandlingSectionType.NO_AGENTS) {
    <ziro-checkbox [fieldId]="'noAgentApplyToNewCallsOnly'"></ziro-checkbox>
  }

  <ziro-radio [fieldId]="'action'"></ziro-radio>

  <div [hidden]="formData.action !== CallQueueExceptionHandlingAction.REDIRECT">
    <div class="row">
      <ziro-select class="col-6" [fieldId]="'redirectType'" [inlineLabel]="false"></ziro-select>
      <div class="col-6">
        <ziro-select [fieldId]="'redirectTarget'" [inlineLabel]="false"></ziro-select>
        <ziro-text [fieldId]="'externalPhoneNumber'" [inlineLabel]="false"></ziro-text>
      </div>
    </div>
    <ziro-checkbox [fieldId]="'enableTranscription'"></ziro-checkbox>
    <ziro-checkbox [fieldId]="'suppressSystemMessage'"></ziro-checkbox>
  </div>

  <ziro-radio [fieldId]="'promptType'"></ziro-radio>
  <div class="row">
    <ziro-textarea class="col-6" [fieldId]="'ttsPrompt'"></ziro-textarea>
  </div>
  <div class="row" [hidden]="formData.promptType !== ExceptionHandlingPromptType.AUDIO_FILE || !isPromptApplicable">
    <div class="col-6">
      <ziro-file-upload [fieldId]="'audioPromptUpload'"></ziro-file-upload>
      @if (audioPromptUploadURL() && acceptedFileTypes.includes(audioPromptFileExtension())) {
        <audio
          [attr.data-automation]="dataAutomation() + '-audio-preview'"
          class="mt-2 w-100"
          controls
          [src]="audioPromptUploadURL()"
          [title]="audioPromptDownloadName()"
        ></audio>
        <a
          [attr.data-automation]="dataAutomation() + '-audio-download'"
          class="btn btn-outline-primary btn-sm mt-2"
          [href]="audioPromptUploadURL()"
          [download]="audioPromptDownloadName()"
        >
          <i [class]="ziroIcons.DOWNLOAD"></i>
          {{ 'tkey;teams_call_queue.exception_handling.prompt.download' | translate }}
        </a>
      }
      <p class="mb-0 font-size-12">{{ 'tkey;teams_call_queue.audio_settings.audio_file.info' | translate }}</p>
    </div>
  </div>
</div>
